// extracted by mini-css-extract-plugin
export default {"card-container":"card_card-container__hTfZY"};